<template>
  <div class="about-page">
    <InfoSection />
  </div>
</template>

<script setup lang="ts">
import InfoSection from '../components/InfoSection.vue'
</script>

<style scoped>
.about-page {
  padding: 2rem;
}
</style>
